export default __webpack_public_path__ + "static/media/uss.81c1321f.png";